import React, { useState, useEffect } from 'react';
import Image from '../../images/about-us.png'
import { Link } from 'react-router-dom'; 
import { getToken } from '../../utils/tokenHelper';
import Star from '../../images/star.png' 

const About = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        // Check if the token exists in localStorage
        const token = getToken();
        if (token) {
            setIsLoggedIn(true);
        }
    }, []);
    return (
        <div className='w-full flex flex-col-reverse gap-6 mt-10 lg:mt-20 items-center justify-center px-6 lg:px-[60px]'>
          <img src={Image} alt="" className='lg:w-full lg:h-[500px]'/> 

          <div className='flex flex-col gap-2  lg:gap-3 items-center '>
            <p className='text-[24px] text-[#069125] instrument-sans-semibold tracking-wider'>
            ABOUT US
            </p>

            <p className='text-2xl lg:text-[40px] instrument-sans-bold tracking-wider text-center  lg:text-4xl'>
            Improving Access to Quality Healthcare
            </p>

            <p className='text-lg text-center  text-[#233126] instrument-sans-medium'>
            Quickcare is committed to democratizing access to reliable <br className='hidden md:block'/> healthcare information.
            </p>

            {/* <div className='grid grid-cols-2 p-1 w-full text-xs text-[#069125]
            md:text-sm lg:mt-4 gap-2'>
                <div className='flex items-center gap-1 '>
                    <CheckCircleOutlineIcon />

                    <p className='text-black'>
                    24/7 Medical Emergency
                    </p>
                </div>

                <div className='flex items-center gap-1'>
                    <CheckCircleOutlineIcon />

                    <p className='text-black'>
                    24/7 Medical Emergency
                    </p>
                </div>

                <div className='flex items-center gap-1'>
                    <CheckCircleOutlineIcon />

                    <p className='text-black'>
                    24/7 Medical Emergency
                    </p>
                </div>

                <div className='flex items-center gap-1'>
                    <CheckCircleOutlineIcon />

                    <p className='text-black'>
                    24/7 Medical Emergency
                    </p>
                </div>
            </div> */}

            <div className="flex gap-4 mt-4">                    
                {isLoggedIn ? (
                    <Link to='/triva' 
                    className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2 text-xs  md:text-base' >
                        <img src={Star} alt="" className='w-[11.5px] h-[8.5px] md:w-[23px] md:h-[17px]'/>
                        <span>Play to Win Now </span>
                    </Link>
                    ) : (
                    <Link to='/login' 
                     className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2 text-xs  md:text-base'>
                        <img src={Star} alt="" className='w-[11.5px] h-[8.5px] md:w-[23px] md:h-[17px]'/>
                        <span>Play to Win Now </span>
                    </Link>
                    )}

                {isLoggedIn ? (
                    <Link to='/health'
                     className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70 text-xs  md:text-base' >
                        Ask AI Doctor
                    </Link>
                ) : (
                    <Link to='/login'
                    className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70 text-xs  md:text-base' >
                        Get Started
                    </Link>
                )}
            </div>
          </div> 
        </div>
    )
}

export default About
